<template>
    <section id="story-slider">
        <b-container class="py-5">
            <slider
                class="mb-4 mb-lg-5"
                :current-id="currentId"
                :stories="stories"
                @prev="goTo(currentId - 1)"
                @next="goTo(currentId + 1)"
                @selected="goTo($event)"
            />
            
            <transition
                name="fade"
                mode="out-in"
            >
                <story
                    :key="currentId"
                    class="mb-lg-5"
                    :story="stories[currentId]"
                    @next="goTo(currentId + 1)"
                />
            </transition>

            <!-- Nav buttons -->
            <b-row align-h="center">
                <b-col
                    class="story-footer d-none d-lg-block"
                    lg="6"
                    offset-lg="3"
                    tabindex="-1"
                    @keydown.left="goTo(currentId - 1)"
                    @keydown.right="goTo(currentId + 1)"
                >
                    <btn-arrow
                        left 
                        :disabled="currentId == 0"
                        @click="goTo(currentId - 1)"
                    />
            
                    <div
                        class="d-inline-block ml-2"
                        @click="goTo(currentId + 1)"
                    >
                        <btn-arrow :disabled="currentId == stories.length - 1" />

                        <span class="small cursor-pointer ml-2">
                            {{ $t('home.slider.nextStory') }}
                        </span>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
import stories from '@/contents/stories.json';
import BtnArrow from '@/components/common/BtnArrow';
import Story from '@/components/home/storySlider/Story';
import Slider from '@/components/home/storySlider/Slider';

export default {
    name: 'StorySlider',
    components: { BtnArrow, Story, Slider },
    data() {
        return {
            stories,
            currentId: 0,
        };
    },
    mounted() {
        // Show the correct story as requested in the route query.
        // Add watcher when mounted because `$el` is not yet available before.
        this.$watch('$route',
            function(route) {
                const type = route.name === 'homeCancer' ? 'cancer' : 'general';

                // Only show stories that have correct type.
                this.stories = stories.filter(story => story.type === type);

                if (route.query.story) {
                    // Scroll to this DOM element.
                    window.scrollTo({
                        top: this.$el.offsetTop,
                        behavior: 'smooth',
                    });
                    
                    // Try to find the story requested in the route query ...
                    const found = this.stories.findIndex(s => s.id === route.query.story);
                    
                    // ... and update `currentId` if the story is found.
                    if (found != -1) this.currentId = found;
                }
            },
            { immediate: true, deep: true },
        );
    },
    methods: {
        goTo(targetId) {
            if (this.stories[targetId]) {
                this.currentId = targetId;
            }
        },
    },
};
</script>
